module.exports = __webpack_public_path__ + "static/media/Trainicon01@3x.698e6d59.png";